/** Markdownのコンテントを示す型 */
export type MarkdownContent = string & { __markdownContent: never }

export const castMarkdownContent = (content: string) => {
  return content as MarkdownContent
}
